/**
 * THE FLEET DOES NOT COME TO SEA — the specs arrive already resolved.
 *
 * `drawing-check.mjs` needs ship geometry only in `resolved()`, and the server resolves before
 * sending, so the browser never reaches this. Eight hull definitions are 48 KB gzipped; a candidate
 * who never opens a drawing should not carry them.
 *
 * It THROWS rather than returning null on purpose. A null would let `resolved()` quietly produce a
 * spec with no geometry and mark a candidate against nothing — a silent wrong mark, which is worse
 * than a loud failure. If this ever fires, something reintroduced a browser dependency on ship
 * geometry and the fix is to resolve it server-side, not to soften this.
 */
export function shipFor() {
  throw new Error('fleet.mjs is not bundled for the browser — drawing specs must arrive pre-resolved');
}
export const FLEET = {};
